import requestProvider from "./axiosHandler";

const getRepresentativeByEmployee = (employeeId) => {

    return requestProvider
        .get(`/customer-represantative/get-by-employee/${employeeId}`)
}

const createRepresentative = (list) => {

    return requestProvider
        .post('/customer-represantative', list)
}

const deleteRepresentative = (id) => {

    return requestProvider
        .delete(`/customer-represantative/${id}`)
}

export {getRepresentativeByEmployee, deleteRepresentative, createRepresentative}